"use client";

import { useEffect } from "react";

export const COOKIE = "efn.settings";
export const DEFAULT_SETTINGS = {
  letterSpacing: false,
  wordSpacing: false,
  lineHeight: false,
  paragraphSpacing: false,
  disableAnimations: false,
};

export const getSettings = () => {
  return {
    ...DEFAULT_SETTINGS,
    ...JSON.parse(localStorage.getItem(COOKIE) || "{}"),
  };
};

const applyAccessibilitySettings = () => {
  const settings = getSettings();
  const fontSize = parseFloat(getComputedStyle(document.body).fontSize);

  document.body.style.lineHeight = settings.lineHeight
    ? `${fontSize * 1.5}px`
    : "";

  document.querySelectorAll("p").forEach((p) => {
    p.style.marginBottom = settings.paragraphSpacing ? `${fontSize * 2}px` : "";
  });

  document.body.style.letterSpacing = settings.letterSpacing
    ? `${fontSize * 0.12}px`
    : "";

  document.body.style.wordSpacing = settings.wordSpacing
    ? `${fontSize * 0.16}px`
    : "";

  if (settings.disableAnimations) {
    document.body.classList.add("disable-animations");
  } else {
    document.body.classList.remove("disable-animations");
  }
};

const Settings = () => {
  useEffect(() => {
    applyAccessibilitySettings();
  }, []);

  return null;
};

export default Settings;
